import { render } from "./Colaboradores.vue?vue&type=template&id=f4c74818&scoped=true"
import script from "./Colaboradores.vue?vue&type=script&lang=js"
export * from "./Colaboradores.vue?vue&type=script&lang=js"

import "./Colaboradores.vue?vue&type=style&index=0&id=f4c74818&scoped=true&lang=css"

import exportComponent from "G:\\Centrion\\projetos\\vue\\sisDemode\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4c74818"]])

export default __exports__